import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareRoadmapClassicRoute: InvariantJiraRoute = {
	name: 'software-roadmap-classic',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap',
};
